// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ptdjtgonyxilanijzugt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB0ZGp0Z29ueXhpbGFuaWp6dWd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQxNTM1MjMsImV4cCI6MjA1OTcyOTUyM30.0dJbiQfJ5OLGGf6FEzrm0FSvwjQIxkiCddvrqakJxlU";

const isDoyenceDomain = (): boolean => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'doyencegroup.com' || host.endsWith('.doyencegroup.com');
};

const COOKIE_MAX_AGE = 2592000; // 30 days, matches Supabase refresh token lifetime

const cookieStorage = {
  getItem: (key: string): string | null => {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === key) return decodeURIComponent(value);
    }
    return null;
  },
  setItem: (key: string, value: string): void => {
    document.cookie = `${key}=${encodeURIComponent(value)}; domain=.doyencegroup.com; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax; Secure`;
  },
  removeItem: (key: string): void => {
    document.cookie = `${key}=; domain=.doyencegroup.com; path=/; max-age=0; SameSite=Lax; Secure`;
  }
};

const storage = isDoyenceDomain()
  ? cookieStorage
  : (typeof window !== 'undefined' ? window.localStorage : undefined);

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});
